import RejectDocumentForm from './RejectDocumentForm';

export default RejectDocumentForm;
